import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { IModule } from 'src/app/interfaces/IModule';
import { selectMenu } from 'src/app/selectors/menu.selector';
import { OurKeycloakService } from 'src/app/services/keycloak.service';
import { SwalToastService } from 'src/app/services/swal.service';

@Component({
  selector: 'app-newreset',
  templateUrl: './newreset.component.html',
  styleUrls: ['./newreset.component.css'],
  standalone: false,
})
export class NewresetComponent {
  password1: string = '';
  password2: string = '';

  passwordFieldType: string = 'password';
  passwordFieldType2: string = 'password';

  constructor(
    private readonly keycloakService: OurKeycloakService,
    private readonly swalToastService: SwalToastService,
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly store: Store
  ) {}

  private menuList: IModule[] = [];

  ngOnInit() {
    this.store.select(selectMenu).subscribe((menu) => {
      this.menuList = menu;
    });
  }

  togglePasswordVisibility(): void {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  togglePasswordVisibility2(): void {
    this.passwordFieldType2 =
      this.passwordFieldType2 === 'password' ? 'text' : 'password';
  }

  getPasswordMsg(): string | undefined {
    if (
      this.password1.length < 8 ||
      !/[A-Z]/.test(this.password1) ||
      !/[a-z]/.test(this.password1) ||
      !/[^a-zA-Z0-9]/.test(this.password1)
    ) {
      return this.translate.instant(
        'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, and one special character'
      );
    }

    if (this.password1 != this.password2) {
      return this.translate.instant('Passwords do not match');
    }

    return undefined;
  }

  passwordValid(): boolean {
    if (
      this.password1.length < 8 ||
      !/[A-Z]/.test(this.password1) ||
      !/[a-z]/.test(this.password1) ||
      !/[^a-zA-Z0-9]/.test(this.password1)
    ) {
      return false;
    }

    if (this.password1 != this.password2) {
      return false;
    }

    return true;
  }

  resetPassword() {
    this.keycloakService.resetPassword(this.password1).subscribe({
      next: () => {
        this.swalToastService.toastSuccess('Password set successfully');
        this.router.navigate(['/ehr/' + this.menuList.at(0)?.path]);
      },
      error: (err) => {
        console.log(err);
        this.swalToastService.toastError(err.error.message);
      },
    });
  }
}
